import { Suggestion, SuggestionKind } from 'owa-search-service';

export default function orderSuggestions(suggestions: Suggestion[]): Suggestion[] {
    /**
     * We really shouldn't be re-ordering suggestions returned from the service.
     * The most we should do is ensure that client-side suggestions (i.e. category)
     * are last in the list. The try suggestions will be shown for zero query and will appear at the top
     */

    const clientTrySuggestions = suggestions.filter((suggestion: Suggestion) => {
        return suggestion.kind === SuggestionKind.TrySuggestion;
    });

    const serverSuggestions = suggestions.filter((suggestion: Suggestion) => {
        return (
            suggestion.kind !== SuggestionKind.Category &&
            suggestion.kind !== SuggestionKind.TrySuggestion
        );
    });

    const clientSuggestions = suggestions.filter((suggestion: Suggestion) => {
        return suggestion.kind === SuggestionKind.Category;
    });

    return [].concat(clientTrySuggestions, serverSuggestions, clientSuggestions);
}
